// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__4egWY","logoIcon":"Logo_logoIcon__AFIxU"};